import { TranslationEntity } from '../types';

export enum SurveyExtensionPoint {
  BEFORE_JOINING_WAITINGLIST = 'BEFORE_JOINING_WAITINGLIST',
  BEFORE_PAYMENT = 'BEFORE_PAYMENT',
  AT_CHECKOUT = 'AT_CHECKOUT',
  AFTER_EVENT = 'AFTER_EVENT',
  AT_GUEST_INVITATION = 'AT_GUEST_INVITATION',
  AFTER_REGISTRATION = 'AFTER_REGISTRATION',
  AFTER_NEXT_SIGN_IN = 'AFTER_NEXT_SIGN_IN',
}

export enum SurveyStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
}

export enum QuestionStructureType {
  FREE_TEXT = 'FREE_TEXT',
  CHECK_BOX = 'CHECK_BOX',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  PHONE_NUMBER = 'PHONE_NUMBER',
}

export enum QuestionType {
  FREE_TEXT = 'FREE_TEXT',
  CHECKBOX = 'CHECKBOX',
  MULTIPLE_CHOICE_RANGE = 'MULTIPLE_CHOICE_RANGE',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  MULTIPLE_CHOICE_DROPDOWN = 'MULTIPLE_CHOICE_DROPDOWN',
  MULTIPLE_CHOICE_MULTIPLEANSWER = 'MULTIPLE_CHOICE_MULTIPLEANSWER',
  MULTIPLE_CHOICE_WITH_OTHER = 'MULTIPLE_CHOICE_WITH_OTHER',
  MULTIPLE_CHOICE_WITH_OTHER_DROPDOWN = 'MULTIPLE_CHOICE_WITH_OTHER_DROPDOWN',
  MULTIPLE_CHOICE_AUTO_COMPLETE = 'MULTIPLE_CHOICE_AUTO_COMPLETE',
  MULTIPLE_CHOICE_AUTO_COMPLETE_MULTIPLEANSWER = 'MULTIPLE_CHOICE_AUTO_COMPLETE_MULTIPLEANSWER',
  MULTIPLE_CHOICE_WITH_OTHER_AUTO_COMPLETE = 'MULTIPLE_CHOICE_WITH_OTHER_AUTO_COMPLETE',
  MULTIPLE_CHOICE_WITH_OTHER_AUTO_COMPLETE_MULTIPLEANSWER = 'MULTIPLE_CHOICE_WITH_OTHER_AUTO_COMPLETE_MULTIPLEANSWER',
  STRUCTURED = 'STRUCTURED',
  STRUCTURED_MULTIPLEANSWER = 'STRUCTURED_MULTIPLEANSWER',
}
/**
 * Which Insights metric a survey question feeds.
 *
 * Set per question PER SURVEY (`survey_questions.role`), never on the reusable question itself, and
 * never inferred: Insights reads this tag, not the question's wording, order, or the fact that it
 * happens to be a 0-10 range. A Net Promoter role names its subject, because a recommendation of
 * the brand and one of the experience are not comparable figures — see ADR-0021. The Java domain
 * enum is authoritative; this mirror and the Node one must match it.
 */
export enum SurveyQuestionRole {
  SATISFACTION = 'SATISFACTION',
  NPS_EXPERIENCE = 'NPS_EXPERIENCE',
  NPS_BRAND = 'NPS_BRAND',
  EASE = 'EASE',
  SELF_USE = 'SELF_USE',
  /** @deprecated Readable until the fleet is off it; never offered — subject unknown (ADR-0021). */
  NPS = 'NPS',
}

/** The roles a question can be tagged with. Deprecated `NPS` is readable, never authorable. */
export type AuthorableSurveyQuestionRole = Exclude<
  SurveyQuestionRole,
  SurveyQuestionRole.NPS
>;

export enum SurveyInputMode {
  EDITABLE = 'EDITABLE',
  LOCKED = 'LOCKED',
}
